import siteApiClient from '../services/siteApiClient';

export default {
	namespaced: true,
	state: {
		wiki: null,
	},
	getters: {
		wiki(state) {
			return state.wiki;
		},
	},
	mutations: {
		SET_WIKI(state, wiki) {
			state.wiki = wiki
		},
	},
	actions: {
		async getWiki({commit}) {
			await siteApiClient.get('wiki/getList').then(res => {
				commit('SET_WIKI', res.data);
			}).catch(err => {
				console.log(err)
			})
		},
	}
}
